import React from "react";

type PerfilContextType = {};

const defaultValue: PerfilContextType = {};

export const PerfilContext = React.createContext(defaultValue);

export default function PerfilContextProvider(props: {
  children: React.ReactNode;
}) {
  return (
    <PerfilContext.Provider value={{}}>{props.children}</PerfilContext.Provider>
  );
}
